import React from "react";
import { Loader, SimpleTable } from "components";
import { useGetAirtimeToCashPhoneNumberHistory } from "api/actions/transactionKap";

const phoneHistoryColumns = [
  { label: "Name", id: "staffName" },
  { label: "Email", id: "email", align: "left" },
  {
    label: "Previous",
    id: "changedFrom",
    align: "left",
  },
  {
    label: "Changed To",
    id: "changedTo",
    align: "left",
  },
  {
    label: "Date Changed",
    id: "dateChanged",
    align: "left",
  },
  {
    label: "Device",
    id: "device",
    align: "left",
  },
];
export default function UpdatePhoneHistory() {
  const { isFetching, phoneUpdateHistory } =
    useGetAirtimeToCashPhoneNumberHistory();

  return (
    <div>
      <div className="p-3 bg-white rounded dark:bg-gray-900">
        <div>
          {!isFetching ? (
            <div className="col-span-1">
              <div className="bg-white rounded-lg dark:bg-gray-900">
                <SimpleTable
                  headerCellClassName="font-bold dark:!bg-[#143414] text-2xl " // Header cell specific styles
                  columns={phoneHistoryColumns}
                  rows={phoneUpdateHistory.map((history) => ({
                    ...history,
                    device: <DeviceInfo device={history.device} />,
                  }))}
                />
              </div>
            </div>
          ) : (
            <div className="relative flex items-center justify-center w-full h-40 p-6 rounded bg-box shadow-card-box dark:bg-gray-900">
              <Loader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const DeviceInfo = ({ device }) => {
  if (!device) return null;

  const { client = {}, device: deviceInfo = {}, os = {} } = device;

  return (
    <div style={{ fontSize: "14px", color: "#666" }}>
      <div>Browser: {client?.name || "Unknown"}</div>
      <div>
        Device name:{" "}
        {`${deviceInfo?.brand || "Unknown"} (${deviceInfo?.type || "unknown"})`}
      </div>
      <div>
        Hardware:{" "}
        {`${os?.name || "Unknown"}${
          os?.version ? `, Version ${os.version}` : ""
        }`}
      </div>
    </div>
  );
};
